module.exports = __webpack_public_path__ + "img/jzg.4bdd3194.png";